import { getLink } from "../../../../utils/utils";

import translator from "../translator";

const content = {
	esp: (
		`
		<p class="mb-3">
			Ekzistas tiu infana ludo – kubetoj. 
			Metu ilin unu super aliun, kaj vi konstruos turon. 
			Kvankam tiu turo ne estas vera, la Kubetoj mem rilatas al ĝi serioze, kvazaŭ tio ne estus ludo, sed solida plenkreskula laboro.
		</p>
		
		<p class="mb-3">
			Ĉu vi scias, pri kio pensas Kubetoj dum la ludo? Pri tute diversaj aferoj. 
			Ja ilia stato estas tute diversa. 
			La Malsupra Kubeto pensas, kiel la tutan turon sur si subteni; kaj la Supra Kubeto – kiel sin mem supre reteni.
		</p>
		
		<p class="mb-3">
			Jen tial, se vi forprenos la Supran Kubeton, la turo malmulte ŝanĝiĝos. 
			Sed provu ja forpreni la Malsupran…
		</p>
		`
	)
}

const itemName = {
	esp: 'Kubetoj'
}

const item = {
	itemlink: getLink(itemName.esp),
	esp: {
		itemName: itemName.esp,
		itemContent: content.esp,
		itemTranslator: translator.esp
	}
}

export default item;